// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__36gjB","ThumbZoom":"ChapterPlayer_ThumbZoom__vcDU-"};